import { useSelector } from 'react-redux';
import { FileUploadOptions } from '@wix/da-shared-react/pkg/utils/hooks/useFileUpload';
import { MIME_CONFIG } from '@wix/da-shared-react/pkg/utils/mime';
import { getActiveSection, getSelectedFolder } from '../selectors/studio';
import { StudioSection } from '../types/store';
import { STUDIO_UPLOADS_NAMESPACE } from '../../constants';

export function useStudioUploadOptions(
  options?: FileUploadOptions
): FileUploadOptions {
  const selectedFolder = useSelector(getSelectedFolder);
  const isStashSection = useSelector(getActiveSection) === StudioSection.STASH;

  return {
    id: STUDIO_UPLOADS_NAMESPACE,
    acceptedMimeTypes: MIME_CONFIG.forDeviationSubmit,
    allowMultiple: true,
    useDefaults: true,
    isDraft: !isStashSection,
    folderId: isStashSection ? selectedFolder?.folderId : undefined,
    ...options,
  };
}
